<template>
  <div class='sub-page'>
    <div class='sub-tab-wrap'>
      <DxTabPanel
          id="tabpanel"
          :selected-index.sync="selectedIndex"
          :data-source='tabs'
          :focusStateEnabled='true'
        >
        <template #title="{ data: tab }">
          <div class='sub-title-wrap-tab'>
            <ul>
              <li class='float-left sub-title'>{{tab.title}}</li>
            </ul>
          </div>
        </template>
      </DxTabPanel>
    </div>
    <CurrentPurchaseStockAdjust v-if='selectedIndex === 0'/>
    <CurrentProductionStockAdjust v-if='selectedIndex === 1'/>
    <CurrentSemiProductionStockAdjust v-if='selectedIndex === 2'/>
    <CurrentWipStockAdjust v-if='selectedIndex === 3'/>
    <StockAdjustHistory v-if='selectedIndex === 4'/>
  </div>
</template>

<script>
import ConstDef from '../../../share/ConstDef'
import DxTabPanel from 'devextreme-vue/tab-panel'
import CurrentPurchaseStockAdjust from './CurrentPurchaseStockAdjust'
import CurrentProductionStockAdjust from './CurrentProductionStockAdjust'
import CurrentSemiProductionStockAdjust from './CurrentSemiProductionStockAdjust'
import CurrentWipStockAdjust from './CurrentWipStockAdjust'
import StockAdjustHistory from './StockAdjustHistory'

export default {
  name: 'CurrentStockTab',
  data: function () {
    return {
      selectedIndex: 0,
      tabs: []
    }
  },
  components: {
    DxTabPanel,
    CurrentPurchaseStockAdjust,
    CurrentProductionStockAdjust,
    CurrentSemiProductionStockAdjust,
    CurrentWipStockAdjust,
    StockAdjustHistory
  },
  created () {
    document.title = ConstDef.TAB_TITLE
    let user = this.$store.getters.getUserInfo
    if (user === undefined || user === null) {
      this.$router.push('/')
    }
    const topMenuTab = this.$store.getters.getTopMenuTabByUrl(this.$route.path)
    if (topMenuTab !== null) {
      const tabNameArray = topMenuTab.multiTabName.split('/')
      for (let i = 0; i < tabNameArray.length; i++) {
        let temp = {}
        temp.title = tabNameArray[i]
        this.tabs.push(temp)
      }
    }
  },
  mounted () {

  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {

  }
}
</script>

<style lang="scss">

</style>
